import { getLogger } from '../logger';
import type { Platform } from './types';

const logger = getLogger('react/utils/platform');

let gPlatform: Platform | null | undefined = null;

export const initialize = (platform: Platform | undefined): void => {
  gPlatform = platform;
  logger.info('Platform=', platform);
};

export { gPlatform as default };
